import React from "react";

import {
  Box,
  ChevronLink,
  Column,
  Columns,
  Heading,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { IconHome, IconBilling } from "@origin-digital/ods-icons";
import content from "./content.json";
import {
  BugIcon,
  ClockIcon,
  FlashIcon,
} from "src/pages/Spike/components/Icons";

enum Icon {
  Home = "Home",
  Billing = "Billing",
  Clock = "Clock",
  Bug = "Bug",
  Flash = "Flash",
}
const IconMap = {
  [Icon.Home]: <IconHome size="medium" />,
  [Icon.Billing]: <IconBilling size="medium" />,
  [Icon.Clock]: <ClockIcon size="medium" />,
  [Icon.Bug]: <BugIcon size="medium" />,
  [Icon.Flash]: <FlashIcon size="medium" />,
};

export const FAQSection: React.FC = () => (
  <Section>
    <Box paddingX={["none", "xxxlarge"]}>
      <Stack alignX="center" space="xxlarge">
        <Heading variant="h2">{content.heading}</Heading>
        <Columns collapseBelow="md" alignX="center">
          {content.sections.map((section, index) => (
            <Column width="flex" key={index}>
              <Stack alignX="center">
                {IconMap[section.icon]}
                <Stack space="xsmall" alignX="center">
                  <Heading variant="h4" align="center">
                    {section.heading}
                  </Heading>
                  <Text align="center">{section.text}</Text>
                </Stack>
                <ChevronLink href={section.link} variant="secondary">
                  Find out more
                </ChevronLink>
              </Stack>
            </Column>
          ))}
        </Columns>
      </Stack>
    </Box>
  </Section>
);
